import { AcaoDeVenda } from './../domain/acao-de-venda.model';
import { DomainSerializer } from "src/app/global/serializables/domain.serializer";

export class AcaoDeVendaSerializer extends DomainSerializer<AcaoDeVenda> { }
